export const getCanSave = (values) => {
  const { category, subject, content } = values || {};
  return !!category && !!subject && !!content;
};
